import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormInput from '../../Common/formInput';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import { makeStyles, withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Snackbar from '@material-ui/core/Snackbar';
import { Grid,InputLabel} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TextField from '@material-ui/core/TextField';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Modal from '../../Modal';
import moment from 'moment';
import InfoIcon from '@material-ui/icons/Info';
import visa from '../../../assets/Visa.png';
import mastercard from '../../../assets/mastercard.png';
import discover from '../../../assets/discover.png';
import american from '../../../assets/american.png';
import currentUserSelector from '../../../selectors/currentUserSelector';
import { subscriptionInfoSelector } from '../../../selectors/subscription';
import { getUserDetailsData, getUserSubscriptionInfo, updateUserSubscriptionInfo } from '../../../actions/get-user-details';
import { showSuccessSnackbar } from '../../../actions/snackbar';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Card, CardContent } from '@material-ui/core';
import CheckoutForm from './checkoutForm';

const IncrementTextField = (props) => {
    const inputRef = useRef(null);
    useEffect(() => {
        if (inputRef?.current) {
            inputRef.current.addEventListener('keydown', (event) => event.preventDefault());
        }
        return () => inputRef?.current?.removeEventListener('keypress');
    }, [inputRef])
    return (
        <TextField
            {...props}
            inputRef={inputRef}
        />
    )
};

const useStyles = makeStyles(() => ({
    datePickerInput:{
        paddingRight:20,
        marginBottom:10,
        '& .MuiOutlinedInput-input':{
            padding:'0.5rem 1rem'
        }
    },
    table: {
        // border: '1px solid #08090A20'
    },
    tableSubtitle: {
        padding: '0.5rem',
        textAlign: 'center',
        fontWeight: 400,
        fontSize: '1rem',
        fontWeight: 400,

    },
    tableHeader: {
        padding: '1rem',
        textAlign: 'center',
        border: '1px solid #08090A20',
        marginBottom: '1rem',
        backgroundColor: '#F9D342',
    },
    tableHeaderTypo: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.5,
        color: '#08090A',
        textAlign: 'center',
    },
    planHeader: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px 15px',
        backgroundColor: '#F9D342',
    },
    plantitleTypo: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.5,
        color: '#08090A',
        textAlign: 'center',
    },
    planPriceTypo: {
        fontSize: '0.875rem',
        fontWeight: 500,
    },
    notSelected: {
        opacity: 0.5,
    },
    selected: {
        fontWeight: 500,
    },
    tableContainer: {
        overflowY: 'auto',
    },
    upgradeBox: {
        display: 'flex',
        flexDirection: 'row-reverse',
        padding: '2rem 0',
    },
    infoIcon: {

    },
    info: {
        fontSize: '0.75rem',
        marginLeft: '0.1rem'
        // position:'absolute',
        // top:'0',
        // right:0,
    },
    tooltip: {
        fontSize: '10px',
        padding: '5px 10px',
    },
    // button:{
    //     marginTop:'10px',
    //     borderRadius:'20px',
    //     '&:hover':{
    //         marginTop:'10px',
    //         borderRadius:'20px',
    //     },
    //     '&:active': {
    //         marginTop:'10px',
    //         borderRadius:'20px',
    //     },
    //     '&:active': {
    //         marginTop:'10px',
    //         borderRadius:'20px',
    //     },
    // },
    IconButton: {
        padding: '0px',
        fontSize: '12px',
    },
    infoCount: {
        margin: '0px 10px',
    },
    pointer: {
        height: 0,
        width: 0,
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderTop: '15px solid #F9D342',
    },
    nullPointer: {
        height: 0,
        width: 0,
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderTop: '15px solid #FFFFFF',
    }
}));

const StyledTableHeaderCell = withStyles({
    root: {
        padding: '10px',
        textAlign: 'center',
        border: 'none',
        // border: '1px solid #08090A20',
    }
})(TableCell);

const StyledTableCell = withStyles({
    root: {
        padding: '0.5rem',
        textAlign: 'center',
        border: 'none',
        borderBottom: '1px solid #08090A20',
    }
})(TableCell);

const StyledTitleTableCell = withStyles({
    root: {
        padding: '0.5rem',
        textAlign: 'left',
        border: 'none',
        borderBottom: '1px solid #08090A20',
    }
})(TableCell);

const EmptyTableCell = withStyles({
    root: {
        border: 'none',
        textAlign: 'center',
        padding: '10px'
    }
})(TableCell);

const CustumTextField = withStyles({
    root: {
        color: '#12100F',
        fontSize: '0.875rem',

        maxWidth: '6rem',
    }
})(IncrementTextField);

// const CustomButton = withStyles((theme)=>({
//     root:{
//         marginLeft: '0.5rem', 
//         borderRadius:'20px',
//         '&:hover':{
//         },
//     },
//     disabled:{
//         marginLeft: '0.5rem', 
//         borderRadius:'20px',
//     }
// }))(Button);

export default function PackagesForm(props) {
    const [publicKey, setKey] = useState('pk_live_Xhm5mtPuQOJFarOf0pogv66i00vH5kLUzu');
    // const [publicKey, setKey] = useState('pk_test_MU3xLLM0majqVEQzDkzYeA5h009dI3g9hM');
    const [stripePromise, setStripePromise] = useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [activePlan, setActivePlan] = React.useState(0);
    const [openConfirmModal, setOpenConfirmModal] = React.useState(false);
    const [confirmModalTitle, setConfirmModalTitle] = React.useState('');
    const [loadingUpgrade, setLoadingUpgrade] = React.useState(false);
    const [snackBarMessage, setSnackBarMessage] = React.useState('');


    const [accountPerChannel, setAccountPerChannel] = React.useState(0);
    const [brandPerPackage, setBrandPerPackage] = React.useState(0);
    const [userCount, setUserCount] = React.useState(0);
    const [maxStorage, setMaxStorage] = React.useState(1);
    const [deleteMessage, setDeleteMessage] = React.useState('');
    const [buyPlan, setBuyPlan] = React.useState('');
const [code,setCode]= React.useState('');
    const [cardNumber, setCardNumber] = React.useState('');
    const [cvv, setCVV] = React.useState();
    const [expiryDate, setExpiryDate] = React.useState();
    const [btnText,setBtnText] = useState(null);

    const currentUser = useSelector(currentUserSelector);
    const subscriptionDetails = useSelector(subscriptionInfoSelector);
    const [paymentMethodId,setPaymentMethodId] = useState(null);
    const handlePaymentMethodId = (paymentMethodId) => {
        setPaymentMethodId(paymentMethodId);
    }
    const handleFetchedCard = (card) => {
        console.log("card fetched")
    }
    // const packageInformation = useSelector(state => state.entities.packageInformation[1]);
    // const { name: planName, maxStorageSize, maxFileSize, expiryDate,
    //     acOnEachPlatform: noOfAccounts, currentStorageSize,
    //     priceInfo } = packageInformation;
    const dispatch = useDispatch();

    const handlCloseSnackBar = () => {
        setTimeout(() => setSnackBarMessage(''), 6000);
    }

    const handlClose = () => {
        setSnackBarMessage('');
    }

    const userPackageData = [
        {
            planName: 'Professional',
            maxFileSize: 300,
            accountPerChannel: 5,
            brands: 1,
            maxStorage: 1,
            userCount: 1,
            price: 19
        },
        {
            planName: 'Business',
            maxFileSize: 1000,
            accountPerChannel: 5,
            brands: 3,
            maxStorage: 25,
            userCount: 3,
            price: 59
        },
        {
            planName: 'Premium',
            maxFileSize: 'N/A',
            accountPerChannel: 'N/A',
            brands: 'N/A',
            maxStorage: 'N/A',
            userCount: 'N/A',
            price: 399
        }
    ]

    const PRODUCT_PRICE_ID = {
        USERS: 'price_1NDcMpF0baSPJSQUBLyoYWBQ',
        SOCIAL_ACCOUNT: 'price_1NDcK0F0baSPJSQU1gKtGjEM',
        BRANDS: 'price_1NDcCtF0baSPJSQUWKBDSKnV',
        STORAGE: 'price_1NDcAjF0baSPJSQUmk815ZHC',
        BUSINESS: 'price_1NDbnzF0baSPJSQUNXeJ2TF0',
        PROFESSIONAL: 'price_1NDbh6F0baSPJSQUdwk7CxRY',
    }

    const costForUpgrade = {
        brandPerChannel: 2,
        costPerGBStorage: 1,
        costPerProfile: 5,
        costPerUser: 5,
    }

    const totalCostUpgrade = useMemo(() => {

        const { userPackageInfo } = subscriptionDetails;
        console.log("selected pack",userPackageInfo);
        // const { brand_units: brands, social_account_units: channel, storage_units: storage, user_units: packageUser } = userPackageInfo;
        const { brandPerChannel, costPerGBStorage, costPerProfile, costPerUser } = costForUpgrade;
        let newCost = ((accountPerChannel - 5) * costPerProfile) +
        ((brandPerPackage - 1) * brandPerChannel) +
        ((maxStorage - 1) * costPerGBStorage) +
        ((userCount - 1) * costPerUser);
        console.log("cost calculation",accountPerChannel,brandPerPackage,maxStorage,costPerProfile,brandPerChannel,newCost)
        return newCost;
    }, [costForUpgrade, accountPerChannel, brandPerPackage, maxStorage, userCount, subscriptionDetails]);
    
    const getUserDetails = async () => {
        setIsLoading(true);
        await dispatch(getUserDetailsData({ user_id: currentUser.user.id }));
        await dispatch(getUserSubscriptionInfo());
        setIsLoading(false);
    }

    useEffect(() => {
        getUserDetails();
    }, []);

    useEffect(() => {
        const { userPackageInfo,name } = subscriptionDetails;
        console.log("Plan details>>",name)
        if (userPackageInfo.name) {
            const { brand_units, item_list, price_info, social_account_units, storage_units, user_units } = userPackageInfo;
            const activeAccountDetails = userPackageData.filter(plan => plan.planName.toUpperCase() === name?.toUpperCase());
            console.log("Plan details",subscriptionDetails)
            if (activeAccountDetails[0]?.planName) {
                setActivePlan(activeAccountDetails[0]);
                setAccountPerChannel(social_account_units);
                setBrandPerPackage(brand_units);
                setMaxStorage(storage_units);
                setUserCount(subscriptionDetails.user_units);
            }
            if(userPackageInfo.isTrial){setBtnText("Subscribe")}
            else {
                
                setBtnText("Confirm")
            }
        }
    }, [subscriptionDetails]);


    useEffect(() => {
        const optedPlan = userPackageData.filter(plan => plan.planName === activePlan.planName)[0];
        const content = Boolean(buyPlan) ?
            `Moving to ${userPackageData[1].planName} plan will cost $${userPackageData[1].price}.` 
            : 
            `Upgrade cost of $${totalCostUpgrade} will be added to your invoice.`;
            
        setDeleteMessage(`${content}`);
        return () => setDeleteMessage('');
    }, [buyPlan,totalCostUpgrade]);

    const handleConfirmUpgrade = async () => {
        const { userPackageInfo } = subscriptionDetails;
        const { brand_units, item_list, name, price_info, social_account_units, storage_units, user_units } = userPackageInfo;

        const planPriceDetails = item_list.filter(({ price_id }) => price_id === PRODUCT_PRICE_ID[activePlan.planName.toUpperCase()])[0];

        setLoadingUpgrade(true);
        const purchagesPlanList = [
            { ...planPriceDetails },
            {
                price_id: PRODUCT_PRICE_ID['USERS'],
                quantity: (userCount - activePlan.userCount),
            },
            {
                price_id: PRODUCT_PRICE_ID['BRANDS'],
                quantity: (brandPerPackage - activePlan.brands),
            },
            {
                price_id: PRODUCT_PRICE_ID['STORAGE'],
                quantity: (maxStorage - activePlan.maxStorage),
            },
            {
                price_id: PRODUCT_PRICE_ID['SOCIAL_ACCOUNT'],
                quantity: (accountPerChannel - activePlan.userCount),
            },
        ];
        // Below is the real data from state variables so commented
        // const data = {priceId:1,brandUnits:brandPerPackage,userUnits:1,storageUnits:maxStorage,socialAccountUnits:accountPerChannel,cardNumber:parseInt(cardNumber),cvc:parseInt(cvv),expiryMonth:moment(expiryDate).month()+1,expiryYear:moment(expiryDate).year()}
        // Below is the data for subscribing for first time
        
        const data = {priceId:1,brandUnits:1,userUnits:1,storageUnits:1,socialAccountUnits:5,cardNumber:parseInt(cardNumber),cvc:parseInt(cvv),expiryMonth:moment(expiryDate).month()+1,expiryYear:moment(expiryDate).year()}
        
        console.log("clicked1",data)

        dispatch(updateUserSubscriptionInfo(data)).then(data => {
            setLoadingUpgrade(false);
            setOpenConfirmModal(false);
            if(subscriptionDetails.isTrial==false)
            setBtnText("Confirm")
            // dispatch(getUserSubscriptionInfo());
        });
    }

    const switchPlan = () => {
        setLoadingUpgrade(true);
        const { userPackageInfo } = subscriptionDetails;
        const { brand_units, social_account_units, storage_units, user_units } = userPackageInfo;
        
        let data=null;
        if(activePlan.planName=='Business')
        {
            if(subscriptionDetails.isTrial==true)
            {
                if(code!=null || code!='')
                {
                data = {priceId:2,brandUnits:userPackageData[1].brands,userUnits:userPackageData[1].userCount,storageUnits:userPackageData[1].maxStorage,socialAccountUnits:userPackageData[1].accountPerChannel,payment_method_id:paymentMethodId,affiliateCode:code}
                }
                else{
                    data = {priceId:2,brandUnits:userPackageData[1].brands,userUnits:userPackageData[1].userCount,storageUnits:userPackageData[1].maxStorage,socialAccountUnits:userPackageData[1].accountPerChannel,payment_method_id:paymentMethodId}
                }
            }
            else{
            // data = {priceId:2,brandUnits:3,userUnits:5,storageUnits:25,socialAccountUnits:30,payment_method_id:paymentMethodId}
            data = {priceId:2,brandUnits:brandPerPackage,userUnits:userCount,storageUnits:maxStorage,socialAccountUnits:accountPerChannel,payment_method_id:paymentMethodId}
            }
        // data = {priceId:2,brandUnits:brandPerPackage,userUnits:userCount,storageUnits:maxStorage,socialAccountUnits:accountPerChannel,payment_method_id:paymentMethodId}
        }
        else{
            if(subscriptionDetails.isTrial==true)
            {
                if(code!=null || code!='')
                {
                data = {priceId:1,brandUnits:userPackageData[0].brands,userUnits:userPackageData[0].userCount,storageUnits:userPackageData[0].maxStorage,socialAccountUnits:userPackageData[0].accountPerChannel,payment_method_id:paymentMethodId,affiliateCode:code}
                }
                else
                {
                    data = {priceId:1,brandUnits:userPackageData[0].brands,userUnits:userPackageData[0].userCount,storageUnits:userPackageData[0].maxStorage,socialAccountUnits:userPackageData[0].accountPerChannel,payment_method_id:paymentMethodId}
                }
            }
            else{
                // data = {priceId:1,brandUnits:1,userUnits:1,storageUnits:15,socialAccountUnits:5,payment_method_id:paymentMethodId}
                data = {priceId:1,brandUnits:brandPerPackage,userUnits:1,storageUnits:maxStorage,socialAccountUnits:accountPerChannel,payment_method_id:paymentMethodId}
            }
            // data = {priceId:1,brandUnits:brandPerPackage,userUnits:1,storageUnits:maxStorage,socialAccountUnits:accountPerChannel,payment_method_id:paymentMethodId}
        }
        console.log("clicked2>>",data,paymentMethodId,activePlan)
        dispatch(updateUserSubscriptionInfo(data)).then(data => {
            setLoadingUpgrade(false);
            setOpenConfirmModal(false);
            setBuyPlan('');
            // console.log("clicked2",subscriptionDetails)
            if(subscriptionDetails.isTrial==false)
            setBtnText("Confirm")
            // dispatch(getUserSubscriptionInfo());
        });
    }

    const handleConfirmCancel = () => {
        setOpenConfirmModal(false);
        setDeleteMessage('');
        setConfirmModalTitle('')
        setBuyPlan('')
    }

    const handleSwitch = (planName) => {
        // setSnackBarMessage('Upgrade plan option will be enabled soon. Stay Tuned');
        setBuyPlan(planName);
        setOpenConfirmModal(true);
        setConfirmModalTitle('Confirmation')
    }

    const handleUpgrade = () => {
        // setSnackBarMessage('Buy Add-On will be enabled soon. Stay Tuned');
        setOpenConfirmModal(true);
        setConfirmModalTitle('Confirmation')
    }

    const classes = useStyles();
    const Info = {
        users: 'Switch to Business plan to add more users',
        UpgradeUser: 'Upgrade to add more users',
        brand: 'Upgrade to add additional Brands at $2/Brand.',
        storage: 'Upgrade to get additional storage available at $1/1GB',
        account: 'Upgrade to add additional social profile at $5/Profile',
    }

    const formatCardNumber = (card) => {
        const visibleDigits = 4;
        const hiddenDigits = card.length > visibleDigits ? (card.length - visibleDigits) : card.length;
        return ('*'.repeat(hiddenDigits) + card.slice(hiddenDigits));
    }
    useEffect(() => {
        console.log("key set",publicKey);
         if (publicKey) {
            setStripePromise(loadStripe(publicKey));
          }
    }, [publicKey]);

    return (
        <Box>
            <Box>
                <TableContainer component={'div'} className={classes.tableContainer}>
                    <Table stickyHeader className={classes.table} aria-label="IP list table">
                        <TableBody>
                            {isLoading ? (
                                <TableRow >
                                    <StyledTableCell colSpan={6}>
                                        <Box display='flex' justifyContent='center' alignItems='center' padding='1rem'>
                                            <CircularProgress size={20} className={classes.progress} />
                                        </Box>
                                    </StyledTableCell>
                                </TableRow>) :
                                (<>
                                    {/* <TableRow>
                                        <StyledTableCell component='th' scope='row'>{'Subscription Expire:'}</StyledTableCell>
                                        <StyledTableCell component='th' scope='row'>{moment(expiryDate).format('YYYY-MM-DD')}</StyledTableCell>
                                        <StyledTableCell component='th' scope='row'>{moment(expiryDate).format('YYYY-MM-DD')}</StyledTableCell>
                                    </TableRow> */}
                                    <TableRow>
                                        <EmptyTableCell component='th' scope='row'></EmptyTableCell>
                                        <EmptyTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[0].planName ? classes.selected : classes.notSelected}>
                                            <Box onClick={()=>{setActivePlan(userPackageData[0])}} display="flex" flexDirection="column" alignItems="center">
                                                <Box className={classes.planHeader}>
                                                    <Typography className={classes.plantitleTypo}>
                                                        {`${userPackageData[0].planName}`}
                                                    </Typography>
                                                    <Typography className={classes.planPriceTypo}>
                                                        {`$${userPackageData[0].price}/month`}
                                                    </Typography>
                                                </Box>
                                                <Box className={activePlan.planName === userPackageData[0].planName ? classes.pointer : classes.nullPointer} />
                                            </Box>
                                        </EmptyTableCell>
                                        <EmptyTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[1].planName ? classes.selected : classes.notSelected}>
                                            <Box onClick={()=>{setActivePlan(userPackageData[1])}} display="flex" flexDirection="column" alignItems="center">
                                                <Box className={classes.planHeader}>
                                                    <Typography className={classes.plantitleTypo}>
                                                        {`${userPackageData[1].planName}`}
                                                    </Typography>
                                                    <Typography className={classes.planPriceTypo}>
                                                        {`$${userPackageData[1].price}/month`}
                                                    </Typography>
                                                </Box>
                                                <Box className={activePlan.planName === userPackageData[1].planName ? classes.pointer : classes.nullPointer} />
                                            </Box>
                                        </EmptyTableCell>
                                        <EmptyTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[2].planName ? classes.selected : classes.notSelected}>
                                            <Box onClick={()=>{setSnackBarMessage('Coming Soon!!!');}} display="flex" flexDirection="column" alignItems="center">
                                                <Box className={classes.planHeader}>
                                                    <Typography className={classes.plantitleTypo}>
                                                        {`${userPackageData[2].planName}`}
                                                    </Typography>
                                                    <Typography className={classes.planPriceTypo}>
                                                        {`$${userPackageData[2].price}/month`}
                                                    </Typography>
                                                </Box>
                                                <Box className={activePlan.planName === userPackageData[2].planName ? classes.pointer : classes.nullPointer} />
                                            </Box>
                                        </EmptyTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTitleTableCell component='th' scope='row'>{'Max file size (GB)'}</StyledTitleTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[0].planName ? classes.selected : classes.notSelected}>
                                            {`${userPackageData[0].maxFileSize / 1000}`}
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[1].planName ? classes.selected : classes.notSelected}>
                                            {`${userPackageData[1].maxFileSize / 1000}`}
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'></StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTitleTableCell component='th' scope='row'>
                                            <Box className={classes.infoIcon}>
                                                {'Users'}
                                                <Tooltip title={activePlan.planName === userPackageData[0].planName ? Info.users : Info.UpgradeUser} arrow placement="right-start" classes={{ tooltip: classes.tooltip }} >
                                                    <InfoIcon style={{ marginLeft: '0.25rem', fontSize: '1rem' }} color={"#000"} />
                                                </Tooltip>
                                            </Box>
                                        </StyledTitleTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[0].planName ? classes.selected : classes.notSelected}>
                                            {`${userPackageData[0].userCount}`}</StyledTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[1].planName ? classes.selected : classes.notSelected}>
                                            <Box display="flex" justifyContent="space-evenly" alignItems="center">
                                                {activePlan.planName === userPackageData[1].planName ? (<>
                                                    <IconButton
                                                        className={classes.IconButton}
                                                        disabled={userCount <= 1}
                                                        onClick={(e) => setUserCount(count => Number(count) - 1)}>
                                                        <RemoveCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    <Box component="span" className={classes.infoCount}>{`${userCount}`}</Box>
                                                    {/* <Box component="span" className={classes.infoCount}>{`${userPackageData[1].userCount}`}</Box> */}
                                                    <IconButton
                                                        className={classes.IconButton}
                                                        disabled={userCount > 49}
                                                        onClick={(e) => setUserCount(count => Number(count) + 1)}>
                                                        <AddCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    </>) : (<Typography>{`${userPackageData[1].userCount}`}</Typography>)
                                                }
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'></StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTitleTableCell component='th' scope='row'>
                                            <Box className={classes.infoIcon}>
                                                {'Additional Social Accounts'}
                                                <Tooltip title={Info.account} arrow placement="right-start" classes={{ tooltip: classes.tooltip }} >
                                                    <InfoIcon style={{ marginLeft: '0.25rem', fontSize: '1rem' }} color={"#000"} />
                                                </Tooltip>
                                            </Box>
                                        </StyledTitleTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[0].planName ? classes.selected : classes.notSelected}>
                                            <Box display="flex" justifyContent="space-evenly" alignItems="center">
                                                {activePlan.planName === userPackageData[0].planName ? (<>
                                                    <IconButton
                                                        className={classes.IconButton}
                                                        disabled={accountPerChannel <= userPackageData[0].accountPerChannel}
                                                        onClick={(e) => setAccountPerChannel(count => Number(count) - 1)}>
                                                        <RemoveCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    <Box component="span" className={classes.infoCount}>{`${accountPerChannel}`}</Box>
                                                    {/* <Box component="span" className={classes.infoCount}>{`${userPackageData[0].accountPerChannel}`}</Box> */}
                                                    <IconButton
                                                        className={classes.IconButton}
disabled={accountPerChannel > 9}
                                                        onClick={(e) => setAccountPerChannel(count => Number(count) + 1)}>
                                                        <AddCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    </>) : (<Typography>{`${userPackageData[0].accountPerChannel}`}</Typography>)
                                                }
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[1].planName ? classes.selected : classes.notSelected}>
                                            <Box display="flex" justifyContent="space-evenly" alignItems="center">
                                                {activePlan.planName === userPackageData[1].planName ? (<>
                                                    <IconButton
                                                        className={classes.IconButton}
                                                        disabled={accountPerChannel <= 1}
                                                        onClick={(e) => setAccountPerChannel(count => Number(count) - 1)}>
                                                        <RemoveCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    <Box component="span" className={classes.infoCount}>{`${accountPerChannel}`}</Box>
                                                    {/* <Box component="span" className={classes.infoCount}>{`${userPackageData[1].accountPerChannel}`}</Box> */}
                                                    <IconButton className={classes.IconButton}
disabled={accountPerChannel > 99}
                                                        onClick={(e) => setAccountPerChannel(count => Number(count) + 1)}>
                                                        <AddCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    </>) : (<Typography>{`${userPackageData[1].accountPerChannel}`}</Typography>)
                                                }
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'></StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTitleTableCell component='th' scope='row'>
                                            {'Brands'}
                                            <Tooltip title={Info.brand} arrow placement="right-start" classes={{ tooltip: classes.tooltip }} >
                                                <InfoIcon style={{ marginLeft: '0.25rem', fontSize: '1rem' }} color={"#000"} />
                                            </Tooltip>
                                        </StyledTitleTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[0].planName ? classes.selected : classes.notSelected}>
                                            <Box display="flex" justifyContent="space-evenly" alignItems="center">
                                                {activePlan.planName === userPackageData[0].planName ? (<>
                                                    <IconButton className={classes.IconButton}
                                                        disabled={brandPerPackage <= userPackageData[0].brands}
                                                        onClick={(e) => setBrandPerPackage(count => Number(count) - 1)}>
                                                        <RemoveCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    <Box component="span" className={classes.infoCount}>{`${brandPerPackage}`}</Box>
                                                    {/* <Box component="span" className={classes.infoCount}>{`${userPackageData[0].brands}`}</Box> */}
                                                    <IconButton className={classes.IconButton}
disabled={brandPerPackage > 2}
                                                        onClick={(e) => setBrandPerPackage(count => Number(count) + 1)}>
                                                        <AddCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    </>) : (<Typography>{`${userPackageData[0].brands}`}</Typography>)
                                                }
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[1].planName ? classes.selected : classes.notSelected}>
                                            <Box display="flex" justifyContent="space-evenly" alignItems="center">
                                                {activePlan.planName === userPackageData[1].planName ? (<>
                                                    <IconButton className={classes.IconButton}
                                                        disabled={brandPerPackage <= 1}
                                                        onClick={(e) => setBrandPerPackage(count => Number(count) - 1)}>
                                                        <RemoveCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    <Box component="span" className={classes.infoCount}>{`${brandPerPackage}`}</Box>
                                                    {/* <Box component="span" className={classes.infoCount}>{`${userPackageData[1].brands}`}</Box> */}
                                                    <IconButton className={classes.IconButton}
disabled={brandPerPackage > 9}
                                                        onClick={(e) => setBrandPerPackage(count => Number(count) + 1)}>
                                                        <AddCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    </>) : (<Typography>{`${userPackageData[1].brands}`}</Typography>)
                                                }
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'></StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTitleTableCell component='th' scope='row'>
                                            {'Max Storage Size (GB)'}
                                            <Tooltip title={Info.storage} arrow placement="right-start" classes={{ tooltip: classes.tooltip }} >
                                                <InfoIcon style={{ marginLeft: '0.25rem', fontSize: '1rem' }} color={"#000"} />
                                            </Tooltip>
                                        </StyledTitleTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[0].planName ? classes.selected : classes.notSelected}>
                                            <Box display="flex" justifyContent="space-evenly" alignItems="center">
                                                {activePlan.planName === userPackageData[0].planName ? (<>
                                                    <IconButton className={classes.IconButton}
                                                        disabled={maxStorage <= userPackageData[0].maxStorage}
                                                        onClick={(e) => setMaxStorage(count => Number(count) - 1)}>
                                                        <RemoveCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    <Box component="span" className={classes.infoCount}>{`${maxStorage}`}</Box>
                                                    <IconButton className={classes.IconButton}
                                                        onClick={(e) => setMaxStorage(count => Number(count) + 1)}>
                                                        <AddCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    {/* <Box component="span" className={classes.infoCount}>{`${userPackageData[0].maxStorage}`}</Box> */}
                                                    </>) : (<Typography>{`${userPackageData[0].maxStorage}`}</Typography>)
                                                }
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[1].planName ? classes.selected : classes.notSelected}>
                                            <Box display="flex" justifyContent="space-evenly" alignItems="center">
                                                {activePlan.planName === userPackageData[1].planName ? (<>
                                                    <IconButton className={classes.IconButton}
                                                        disabled={maxStorage <= 1}
                                                        onClick={(e) => setMaxStorage(count => Number(count) - 1)}>
                                                        <RemoveCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    <Box component="span" className={classes.infoCount}>{`${maxStorage}`}</Box>
                                                    <IconButton className={classes.IconButton}
                                                        onClick={(e) => setMaxStorage(count => Number(count) + 1)}>
                                                        <AddCircleOutline fontSize="small" />
                                                    </IconButton>
                                                    {/* <Box component="span" className={classes.infoCount}>{`${userPackageData[1].maxStorage}`}</Box> */}
                                                    </>) : (<Typography>{`${userPackageData[1].maxStorage}`}</Typography>)
                                                }
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'></StyledTableCell>
                                    </TableRow>
                                    {subscriptionDetails.isTrial?
                                    <TableRow>
                                        <StyledTitleTableCell component='th' scope='row'>{'Affiliate'}
                                        <Tooltip title={'If you were referred by one of our affiliate partners please enter their code here'} arrow placement="right-start" classes={{ tooltip: classes.tooltip }} >
                                                <InfoIcon style={{ marginLeft: '0.25rem', fontSize: '1rem' }} color={"#000"} />
                                            </Tooltip>
                                            </StyledTitleTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[0].planName ? classes.selected : classes.notSelected}>
                                            {/* {`${userPackageData[0]?.creatorCode}`} */}
                                            <Box><FormInput
                    id='affiliateCode'
                    name="affiliateCode"
                    value={code}
                    isNoPadding={true}
                    onChange={(e) => setCode(e.target.value)}
                /></Box>
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'
                                            className={activePlan.planName === userPackageData[1].planName ? classes.selected : classes.notSelected}>
                                            {/* {`${userPackageData[1]?.creatorCode}`} */}
                                            <Box><FormInput
                    id='code1'
                    name="affiliateCode"
                    value={code}
                    isNoPadding={true}
                    onChange={(e) => setCode(e.target.value)}
                /></Box>  
                                        </StyledTableCell>
                                        <StyledTableCell component='th' scope='row'></StyledTableCell>
                                    </TableRow>:null}
                                    <TableRow>
                                        <EmptyTableCell component='th' scope='row'></EmptyTableCell>
                                        <EmptyTableCell component='th' scope='row'>
                                            {/* <Button
                                                disableRipple
                                                className={classes.button}
                                                disabled={(activePlan.planName === userPackageData[0].planName && !Boolean(totalCostUpgrade))}
                                                variant="contained"
                                                color="primary"
                                                onClick={activePlan.planName === userPackageData[0].planName ? handleUpgrade : (() => handleSwitch('professional'))}
                                                style={{ borderRadius: '20px', marginTop: '20px' }}
                                            >
                                                {activePlan.planName === userPackageData[0].planName ? 'Buy Add-On' : 'Buy Professional'}
                                            </Button> */}
                                        </EmptyTableCell>
                                        <EmptyTableCell component='th' scope='row'>
                                            <Button
                                                disableRipple
                                                className={classes.button}
                                                // disabled={(paymentMethodId==null || paymentMethodId=='')}
                                                // disabled={(activePlan.planName === userPackageData[1].planName && !Boolean(totalCostUpgrade))}
                                                variant="contained"
                                                color="primary"
                                                // onClick={activePlan.planName === userPackageData[1].planName ? handleUpgrade : (() => handleSwitch('business'))}
                                                onClick={subscriptionDetails.isTrial?handleUpgrade : (() => handleSwitch('business'))}
                                                style={{ borderRadius: '20px', marginTop: '20px' }}
                                            >
                                                {/* {activePlan.planName === userPackageData[1].planName ? 'Buy Add-On' : 'Buy Business'} */}
                                                {/* {subscriptionDetails.isTrial?"Subscribe":"Upgrade"} */}
                                                {btnText}
                                            </Button>
                                        </EmptyTableCell>
                                    </TableRow>
                                </>)}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Modal
                open={openConfirmModal}
                    onConfirm={Boolean(buyPlan) ? switchPlan : switchPlan}
                    title={confirmModalTitle}
                    onClose={handleConfirmCancel}>
                    <Box display='flex' justifyContent='center' alignItems='center' padding='15px 0px'>
                        {loadingUpgrade ? (<CircularProgress size={40} />) :
                            (<Box textAlign='center'>
                                {/* <span>{`${deleteMessage} Please fill card details and click Confirm to proceed.`}</span> */}
                                {subscriptionDetails.isTrial?
                                <>
                                <span>{`Please fill card details and click Confirm to proceed.`}</span>
{stripePromise ? (
        <Elements stripe={loadStripe(publicKey)}>
          <CheckoutForm onPaymentMethodId={handlePaymentMethodId} onCardDetails={handleFetchedCard} />
        </Elements>
      ) : (
        <CircularProgress size={60} />
      )}</>:<span>{`Card details already provided. Please click Confirm to proceed.`}</span>}
                                {/* <Box style={{marginTop:15}} display='flex' flexDirection='row'>
                        <Box style={{padding:'0 6px'}}>        
                <Grid item xs={12} md={12}>
                <Box display='flex' flexDirection='row'>
                <InputLabel style={{width:195}} className={classes.inputLabel}>Card Number</InputLabel>
                <FormInput
                    id='cardNumber'
                    // label='Card Number*'
                    placeholder=""
                    name="cardNumber"
                    //  value={formatCardNumber(cardNumber)}
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                    inputProps={{
                        maxLength: 16,
                        minLength: 16,
                        inputMode: 'numeric'
                    }}
                /></Box>
                    </Grid>
                <Grid item xs={12} md={12}>
                        <Box display='flex' flexDirection='row'>
                        <InputLabel style={{width:195}} className={classes.inputLabel}>Expiry Date</InputLabel>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    className={classes.datePickerInput}
                                    openTo="year"
                                    fullWidth
                                    views={['month', 'year']}
                                    // label='Year'
                                    inputVariant="outlined"
                                    value={expiryDate}
                                    disablePast
                                    onChange={setExpiryDate}
                                    format={'MMM, YYYY'}
                                    InputProps={{className:classes.datePickerInput}}
                                />
                            </MuiPickersUtilsProvider>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={12}>
                    <Box display='flex' flexDirection='row'>
                <InputLabel style={{width:195}} className={classes.inputLabel}>CVV</InputLabel>
                        <FormInput
                            placeholder="eg:123"
                            name="cvv"
                            value={cvv}
                            onChange={(e) => setCVV(e.target.value)}
                            // label='CVV'
                            type={'password'}
                            inputProps={{
                                maxLength: 3,
                                minLength: 3,
                                inputMode: 'numeric'
                            }}
                        /></Box>
                    </Grid>
                    </Box>
                    <Box style={{borderLeft:'2px solid #ededed',padding:'10px 6px'}}><span>We accept all major credit and debit cards:</span>
                    <Box display='flex' flexDirection='row' justifyContent='space-evenly' marginTop={2}>
                    <img src={visa} width="40" style={{border:'1px solid #ededed'}} />
                    <img src={mastercard} width="40" style={{border:'1px solid #ededed'}} />
                    <img src={discover} width="40" style={{border:'1px solid #ededed'}} />
                    <img src={american} width="40" style={{border:'1px solid #ededed'}} />
                    </Box>
                    </Box></Box> */}
                            </Box>)}
                    </Box>
                </Modal>
                {!!snackBarMessage && (
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        autoHideDuration={1000}
                        open={!!snackBarMessage}
                        onClose={handlCloseSnackBar}>
                        <Alert
                            elevation={6}
                            variant="filled"
                            onClose={handlClose}
                            severity="info">
                            {snackBarMessage}
                        </Alert>
                    </Snackbar>
                )}
            </Box>
        </Box>
    )
}
